import httpClient from '../../http/client';
import { backendURL } from '../../lib/config';
import { Plan } from '../../models/plans';

export function fetchPlans(buildingCode: string) {
  return httpClient.get<Plan[]>(
    new URL(
      `/api/v1/public/plans?building-code=${buildingCode}`,
      backendURL,
    ).toString(),
  );
}

/**
 * Where the published Community Fibre plans are: not tied to a building,
 * and narrowed by the backend to the tiers sold on the place's access
 * technology (fttp or gfast, from sequoia) when one is known.
 */
export const communityFibrePlansURL = (technology?: string): string => {
  const query = technology ? `network=communityfibre&technology=${technology}` : 'network=communityfibre';
  return new URL(`/api/v1/public/plans?${query}`, backendURL).toString();
};

export function fetchCommunityFibrePlans(technology?: string) {
  return httpClient.get<Plan[]>(communityFibrePlansURL(technology));
}
